export const environment = {
    production: true,
    enableEncoding: true,

    apiBaseUrl: 'https://kccstp.unionbankofindia.bank.in/v1/ekyc', // ubi url production 2907
    nodeUrl: 'https://kccstp.unionbankofindia.bank.in/v1',

    satSureBaseUrl: 'https://kccstp.unionbankofindia.bank.in',
    irtcUrl:'https://kccstp.unionbankofindia.bank.in/v1',
    webhookUrl:'https://kccstp.unionbankofindia.bank.in',
    kccCustId:"ubikcc",
    cbsStatusFormat: 'sent_to_cbs',
    kccNewUat: "https://kccstp.unionbankofindia.bank.in",
    kccNew_BRE_Checklist: "https://kccstp.unionbankofindia.bank.in",
    serverType: 'PROD',

    imageUrl: 'https://s3.ap-south-1.amazonaws.com/ubi.whatsloanfintech.com/',
    rtcUrl: 'https://api-ubi.whatsloanfintech.com/rtc.html?file=https://api-ubi.whatsloanfintech.com',

    dsaBaseUrl: 'http://shfllaas.whatsloan.com/DSAAdminCrm/DSACRM/public/dsa',
    dsaEkycUrl: 'https://whatsloan.com/DSAAdminCrm/DSACRM/public/ekyc',

    docUrl:'https://api-ubi.whatsloanfintech.com',
  
    shareKey:"MKPzluxXq066hkatRNIFDc7CKJOBMdAi",
    someRandomString: {
      alpha: 'ghTTGIUhu8uy785t78Y796tb7y79HY9H79b587ec46wx69mu90N80V',
      beta: 'Th6gF9jAM1xo30neA02Hj6RSyut76UHKhiuYGUKHUiyi77TG7IGUI',
    },
    creditScoreSetting : {
        credScore:true,
        credCount:true,
        credMenu:"ubi",
    },
    placeHolderSetting : {
      placeholder:"Customer ID",
      demo : "",
      laasName : "UBI LaaS"
    },
    urlSetting : {
      url: 'https://kccstp.unionbankofindia.bank.in/', //production

    },
    disableInput : false,
  };
  